import { ref } from "vue";
import ConduitApiActions from "@/apis/ConduitApiActions";
import { useAppsStore } from "@/pinia/appsStore";
import { useLegacyLastErrorStore } from "@/pinia/legacyLastErrorStore";
import { usePromptStore } from "@/pinia/promptStore";
import { useUserStore } from "@/pinia/userStore";
export const useLive = () => {
  const userStore = useUserStore();
  const appsStore = useAppsStore();
  const legacyLastErrorStore = useLegacyLastErrorStore();
  const realtimeParams = ref(null);

  const liveUrl = (userId, domain, extra = {}) => {
    if (!domain) domain = appsStore.app?.domain;
    if (!appsStore.app?.id || !domain || typeof domain !== "string") return "";
    domain = domain.replace(/^(https?:|)\/\//, "");

    const params = {
      endUserId: userId,
      appId: appsStore.app.id,
      idToken: localStorage.getItem("id_token"),
      perms: {
        canChangeApp: userStore.isCurrentSuperAdmin,
        isSuperAdmin: userStore.isCurrentSuperAdmin,
      },
    };
    if (appsStore.app.flags.ai_tool && (userStore.canUpdateCompany || userStore.isAppAdmin)) {
      params.ai_tool = true;
    }

    // live v2 params
    const url = new URL(`${window.location.protocol}//${domain}`);

    if (url.search.length) {
      domain = url.host;
      if (url.pathname.length) {
        domain = `${domain}${url.pathname}`;
      }

      const urlParams = new URLSearchParams(url.search);
      extra = { ...extra, ...Object.fromEntries(urlParams) };
    }

    const allParams = { ...params, ...extra };

    realtimeParams.value = `?rf_impersonate=${encodeURIComponent(btoa(JSON.stringify(allParams)))}`;

    return `${window.location.protocol}//${domain}/${realtimeParams.value}`;
  };

  const openLiveUrl = (userId, domain, extra = {}) => {
    const url = liveUrl(userId, domain, extra);
    window.open(url, "_blank");
  };

  const promoPreviewParams = async ({ actionGroupId, sequenceId }) => {
    try {
      const promptStore = usePromptStore();
      await ConduitApiActions.getOverrideActions({ actionGroupId, sequenceId });

      const language =
        promptStore.currLanguage === "default" ? "" : `&language=${promptStore.currLanguage}`;
      const variable = sequenceId
        ? `rf_sequence_id=${sequenceId}`
        : actionGroupId
          ? `rf_override_id=${actionGroupId}`
          : null;
      if (!variable) throw Error("sequence_id or action_group_id is required");
      let params = `rf_is_preview=true&${variable}${language}`;

      return params;
    } catch (error) {
      legacyLastErrorStore.sendError(error);
      return "";
    }
  };

  const viewPreview = async (domain, { actionGroupId, sequenceId }) => {
    const params = await promoPreviewParams({ actionGroupId, sequenceId });
    const visitUrl = `//${domain}?${params}`;

    window.open(visitUrl, "_blank");
  };

  return {
    realtimeParams,
    liveUrl,
    openLiveUrl,
    promoPreviewParams,
    viewPreview,
  };
};
